import { ProductDTO, ProductScopeDTO, TotalRewardDTO } from '@shared/dto';
import { toWebpUrl } from '@shared/utils/image-url';

import { Dict } from '../models/custom-types.models';

export interface Step {
  target: number;
  reward: number;
}

export class ProductScope {
  label: Dict;
  name: string;
  logoPath: string;
  description: Dict;
  bannerPath: string;
  productScopeId: number;

  constructor(obj: ProductScopeDTO) {
    this.name = obj.name;
    this.label = obj.label;
    this.description = obj.description;
    this.logoPath = toWebpUrl(obj.logo_path);
    this.productScopeId = obj.product_scope_id;
    this.bannerPath = toWebpUrl(obj.banner_path);
  }
}

// Total Reward
export class TotalReward {
  totalReward: number;

  constructor(obj: TotalRewardDTO) {
    this.totalReward = obj.total_reward;
  }
}

// Product
export class Product {
  label: string;
  barcodeNumber: string;

  constructor(obj: ProductDTO) {
    this.label = obj.label;
    this.barcodeNumber = obj.barcode_number;
  }
}
